import toUpper from 'lodash/toUpper'

// Generate sort string for api query
function fieldToSortStr(sortData, fieldMap) {
  if (sortData && fieldMap) {
    const { field, sort } = sortData

    if (field && sort) {
      const name = fieldMap[field]

      if (name) {
        return `${name}_${toUpper(sort)}`
      }
    }
  }

  return null
}

export default fieldToSortStr
